/*
    Description: The page wrapper for each page
*/
import type { ReadonlyDeep } from 'type-fest';

import React, { FC } from 'react';

type Props = ReadonlyDeep<{
    children: React.ReactNode;
}>;

/**
 * The page wrapper for each page
 * @param param0
 * @param param0.children The children of this component.
 * @returns
 */
export const PageWrapper: FC<Props> = ({
    children,
}: Props): React.ReactElement => {
    return (
        <div className="flex justify-center">
            <div className="w-full p-4 sm:w-5/6 lg:w-3/5">{children}</div>
        </div>
    );
};
